import React, {Fragment} from 'react';
import SearchBoxWrapper from './search-box-wrapper';
import {toURL} from '@homeaway/search-url-parser';
import {Button} from '@homeaway/react-buttons';
import {FormattedHTMLMessage} from 'react-intl';
import {SVGIcon} from '@homeaway/react-svg';
import {SEARCH__16} from '@homeaway/svg-defs';
import edap from '../../edap';
import './details.less';

const onClick = (boardId, role, dated, edapActionLocation) => () => {
    edap.tripboardSearch(boardId, role, dated, edapActionLocation);
};

export const PrivateSearch = ({
    boardCheckIn,
    boardCheckOut,
    adultsCount = 2,
    childrenCount = 0,
    petIncluded = false,
    boardId,
    locale,
    role,
    siteName,
    edapSearchType,
    places,
    numPlaces,
    searchBoxVariant
}) => {
    if (searchBoxVariant === 0 || places.length <= 0) {
        return null;
    }
    const searchTextTitle = 'tripboards.search.prompt';
    const topPlace = places && places[0] && places[0].full;
    if (searchBoxVariant === 2) {
        return (
            <div className="trip-board-details__private-search">
                <SearchBoxWrapper
                    boardId={boardId}
                    arrival={boardCheckIn}
                    departure={boardCheckOut}
                    destination={topPlace}
                    edapActionLocation={edapSearchType}
                    guests={{adultsCount, childrenCount, petIncluded}}
                    locale={locale}
                    role={role}
                    siteName={siteName}
                    searchTextTitle={searchTextTitle}
                    preferStayProps
                />
            </div>
        );
    }
    const numberPlaces = Math.min(numPlaces, places.length);
    const topNPlaces = places.slice(0, numberPlaces);
    return (
        <div className="trip-board-details__private-search-badges">
            <div className="search-box__copy">
                <div className="search-box__title">
                    <FormattedHTMLMessage id={searchTextTitle} defaultMessage={''} description="search title text" />
                </div>
            </div>
            <div className="private-search-badges__button-row">
                {topNPlaces.map((place) => {
                    const placeUrl = toURL(
                        {
                            arrival: boardCheckIn,
                            departure: boardCheckOut,
                            searchTermUuid: encodeURIComponent(place.uuid),
                            adultsCount,
                            childrenCount,
                            petIncluded
                        }
                    );
                    const label = (
                        <Fragment>
                            <SVGIcon markup={SEARCH__16} />
                            <span>{place.simple}</span>
                        </Fragment>
                    );
                    return (
                        <Button
                            onClick={onClick(boardId, role, boardCheckIn && boardCheckOut, edapSearchType)}
                            key={place.full}
                            href={placeUrl}
                            size={'xs'}
                            target="_blank"
                            label={label}
                        />
                    );
                })}
            </div>
        </div>
    );
};

PrivateSearch.defaultProps = {
    isMobile: false,
    boardId: null,
    role: null,
    boardCheckIn: null,
    boardCheckOut: null,
    abacus: {},
    places: [],
    numPlaces: 0,
    searchBoxVariant: 0
};

export default PrivateSearch;



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/private-search.js